import React, { useContext } from 'react'
import { Container, Box, Flex } from 'theme-ui'
import pageContextProvider from '@helpers/pageContextProvider'
import Search from '@widgets/Search'
import { HeaderLogo } from './Header.Logo'
import { HeaderMenu } from './Header.Menu'
import { HeaderColorMode } from './Header.ColorMode'

const styles = {
  wrapper: {
    position: `relative`,
    bg: `headerBg`
  },
  container: {
    position: `relative`,
    zIndex: 10
  },
  logoContainer: {
    flexBasis: [`full`, null, `1/3`],
    marginTop: '5px',
  },
  searchContainer: {
    flexBasis: [`auto`, null, `1/3`],
    minWidth: `auto`,
    order: [3, null, `unset`],
    mx: 3
  },
  menuContainer: {
    flexBasis: [`auto`, null, `1/3`],
    minWidth: `auto`,
    order: [4, null, `unset`],
    marginLeft: '2px',
  },
  colorModeContainer: {
    minWidth: `auto`,
    order: [2, null, `unset`]
  }
}

export const Header = ({ content,amp,  children }) => {
  const context = useContext(pageContextProvider)

  const { services, mobileMenu, darkMode, locale } = context.pageContext
  const algolia = services && services.algolia
  return (
    <Box sx={styles.wrapper}>
      <Container variant='compact' sx={styles.container}>
        <Flex variant='layout.header'>
          <Box sx={styles.logoContainer}>
            <HeaderLogo content={content} amp={amp} />
          </Box>
          {algolia && (
            <Box sx={styles.searchContainer}>
              <Search />
            </Box>
          )}
          <Box sx={styles.menuContainer}>
            <HeaderMenu mobileMenu={mobileMenu} amp={amp} locale={locale} />
          </Box>
          {!amp && 
            <Box sx={styles.colorModeContainer}>
              {darkMode && <HeaderColorMode />}
            </Box>
          }
        </Flex>
      </Container>
      {children}
    </Box>
  )
}
